<template>
  <div class="scroll-container" ref="scrollContainer" @wheel.prevent="handleScroll">
    <div class="scroll-wrapper" ref="scrollWrapper" :style="{top: top + 'px'}">
      <div class="logo" v-if="sidebar.opened">
        <div class="logo-image">
          <img src="https://files.yiyujiehe.com/common/2023-10-24/d6bc6e01b0b6427390b3222203de0bed_logo-text2.png" alt />
        </div>
      </div>
      <div v-else class="close-logo">
        <div class="close-logo-img">
          <img src="https://files.yiyujiehe.com/common/2023-10-24/f88c5cc5c8e34becb617d0f29bfa6df2_logo.png" alt />
        </div>
      </div>
      <slot></slot>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
const delta = 15;

export default {
  name: "scrollBar",
  data() {
    return {
      top: 0
    };
  },
  computed: {
    ...mapGetters(["sidebar"])
  },
  methods: {
    handleScroll(e) {
      const eventDelta = e.wheelDelta || -e.deltaY * 3;
      const $container = this.$refs.scrollContainer;
      const $containerHeight = $container.offsetHeight;
      const $wrapper = this.$refs.scrollWrapper;
      const $wrapperHeight = $wrapper.offsetHeight;
      if (eventDelta > 0) {
        this.top = Math.min(0, this.top + eventDelta);
      } else {
        if ($containerHeight - delta < $wrapperHeight) {
          if (this.top < -($wrapperHeight - $containerHeight + delta)) {
            this.top = this.top;
          } else {
            this.top = Math.max(
              this.top + eventDelta,
              $containerHeight - $wrapperHeight - delta
            );
          }
        } else {
          this.top = 0;
        }
      }
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import "../../styles/variables.scss";

.scroll-container {
  position: relative;
  width: 100%;
  height: 100%;
  background-color: $menuBg;

  .logo {
    width: 100%;
    height: auto;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 20px 0;
    box-sizing: border-box;
  }
  .logo-image {
    width: 144px;
    height: 75px;
    img {
      width: 100%;
      height: 100%;
    }
  }

  .close-logo {
    width: 100%;
    height: auto;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 20px 0;
    box-sizing: border-box;

    .close-logo-img {
      width: 30px;
      height: 30px;

      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  .scroll-wrapper {
    position: absolute;
    width: 100% !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ScrollBar/index.vue